import React, { useState } from 'react';
import axios from 'axios';
import BASE_URL from '../../url';
import { X, AlertTriangle } from 'lucide-react';
import '../styles/PodModals.css';

const AddMemberModal = ({ isOpen, onClose, onMemberAdded, targetTeamId }) => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [errorType, setErrorType] = useState(''); // 'duplicate' | 'general'

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) {
      setError('Please enter a recruiter email.');
      setErrorType('general');
      return;
    }

    try {
      setLoading(true);
      setError('');
      setErrorType('');
      const token = localStorage.getItem('token');
      
      const memberPayload = {
        teamId: targetTeamId,
        email: email
      };

      try {
        await axios.post(`${BASE_URL}/api/teams/members/email`, memberPayload, {
          headers: { Authorization: `Bearer ${token}` }
        });
      } catch (postErr) {
        if (postErr.response && postErr.response.status === 404) {
          await axios.post(`${BASE_URL}/api/recruitment/teams/members/email`, memberPayload, {
            headers: { Authorization: `Bearer ${token}` }
          });
        } else {
          throw postErr;
        }
      }

      onMemberAdded();
      setEmail('');
      onClose();
    } catch (err) {
      console.error('Error adding member:', err);
      const serverMsg = err.response?.data?.message || err.response?.data?.error || 'Failed to add member';
      if (err.response?.status === 409) {
        setError(serverMsg);
        setErrorType('duplicate');
      } else {
        setError(serverMsg);
        setErrorType('general');
      }
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setEmail('');
    setError('');
    setErrorType('');
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="pod-modal-overlay">
      <div className="pod-modal-content">
        <div className="pod-modal-header">
          <h3 className="pod-modal-title">+ Add Member to Pod</h3>
          <span className="pod-modal-close" onClick={handleClose}><X size={20} /></span>
        </div>
        
        <div className="pod-modal-body">
          <form onSubmit={handleSubmit}>
            <div className="pod-modal-form-group">
              <label className="pod-modal-label">Recruiter Email <span className="required">*</span></label>
              <input 
                type="email"
                value={email}
                onChange={(e) => { setEmail(e.target.value); setError(''); setErrorType(''); }}
                placeholder="e.g. recruiter@prophecytechs.com"
                className={`pod-modal-input ${error ? 'input-error' : ''}`}
              />
              <small className="pod-modal-hint">
                The email must exactly match their email in the recruiter system.
              </small>
            </div>

            {error && (
              <div className={`pod-modal-error ${errorType === 'duplicate' ? 'pod-modal-error-duplicate' : ''}`}>
                {errorType === 'duplicate' && <AlertTriangle size={16} style={{ flexShrink: 0 }} />}
                <span>{error}</span>
              </div>
            )}

            <div className="pod-modal-footer">
              <button type="button" onClick={handleClose} className="pod-modal-btn-cancel">Cancel</button>
              <button type="submit" disabled={loading} className="pod-modal-btn-submit">
                {loading ? 'Adding...' : 'Add Member'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddMemberModal;
